import { MeasurementPoint } from '@core/models/installation.model';

export type PointAction = 'bind' | 'change' | 'unbind' | 'history' | 'rename';

export interface PointEditAccess {
  installationActive: boolean;
  canEditBindings: boolean;
}

// A calculated point has no source of its own to bind. The history only reads, so it stays on a
// Retired installation and for a role that may not edit; every other action writes.
export function pointActions(point: MeasurementPoint, access: PointEditAccess): PointAction[] {
  const canEdit = access.installationActive && access.canEditBindings;
  const actions: PointAction[] = [];
  if (point.nature === 'measured') {
    if (canEdit && point.bindingState === 'unbound') {
      actions.push('bind');
    } else if (canEdit) {
      actions.push('change', 'unbind');
    }
    actions.push('history');
  }
  if (canEdit) {
    actions.push('rename');
  }
  return actions;
}
